module.exports = __webpack_public_path__ + "static/media/channel=campaign manager.bd6a85ea.svg";